import React from 'react';
import SEO from '../components/seo';
import useTranslations from '../components/useTranslations';

const NotFound = () => {
  const { pageNotFound, pageNotFoundDescription } = useTranslations();
  return (
  <>
    <SEO title="404: Not found" />
    <h1>{pageNotFound}</h1>
    <p>{pageNotFoundDescription}</p>
  </>);
};

export default NotFound;
